// extracted by css-extract-rspack-plugin
export default {"chip":"_a28a4c2c","active":"_e27688d2","chipPlaceholder":"_9d037aaf"};